import React from 'react'

import {
    OccupancyPill,
    OccupancyPillDot,
    OccupancyPillState,
    OccupancyPillTitle,
} from '../../../../components/scharedStyles/style'

const OccupancyStatusPill = ({ title, busy }) => (
    <OccupancyPill $busy={busy}>
        <OccupancyPillTitle>{title}</OccupancyPillTitle>
        <OccupancyPillState $busy={busy}>
            <OccupancyPillDot $busy={busy} />
        </OccupancyPillState>
    </OccupancyPill>
)

export default OccupancyStatusPill
